import { memo } from 'react';

import { Badge } from '@componentLibrary/Badge';
import { ESparkStatusColors, ESparkStatusVariants } from '@constants/SparkConstants';

import Tooltip from '@components/layout/Tooltip';

import { TSparkStatus } from '@app/types/SparksTypes';

const SparkStatusChip = memo(
    ({
        status,
        customLabel,
        tooltip = undefined,
        size = 'sm',
    }: {
        status: TSparkStatus;
        customLabel?: string | null;
        size?: 'sm' | 'lg';
        tooltip?: any;
    }) => {
        const color = ESparkStatusColors[status];
        const variant = ESparkStatusVariants[status];
        const label =
            customLabel && customLabel?.length && status !== 'Complete' ? customLabel : status;

        const StatusChipComponent = (
            <Badge
                className={`spark-status-chip ${status === 'Expired' ? 'text-gray-400' : ''}`}
                color={color}
                size={size}
                label={label}
                variant={variant}
                data-chromatic="ignore"
            />
        );

        if (tooltip) {
            return (
                <Tooltip title={tooltip}>
                    <div>{StatusChipComponent}</div>
                </Tooltip>
            );
        }

        return StatusChipComponent;
    },
);

export default SparkStatusChip;
